// Modules
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// Styles
import Styles from "./Styles/userPanelCard.module.css";
// Images
import deleteIcon from "../../../../Assets/Icons/dark-close.png";

const UserPanelCard = ({
  title1,
  title2,
  title3,
  subjects,
  handleDeleteSavedItem,
  kind,
}) => {
  return (
    <div style={{ color: "white" }} className={Styles.container}>
      <div className={Styles.titleContainer}>
        {title3 && <h2 className={Styles.title3}>{title3}</h2>}
        <h2 className={Styles.title}>{title2}</h2>
        <h2 className={Styles.title}>{title1}</h2>
      </div>
      <div className={Styles.separator}></div>
      <div
        className={Styles.detailsContainer}
        style={
          subjects.length === 0
            ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }
            : {}
        }
      >
        {subjects.length !== 0
          ? subjects.map((item, key) =>
              kind ? (
                <Link
                  style={key === 0 ? { marginTop: "0" } : {}}
                  key={key}
                  className={Styles.bookContainer}
                  to={`/library/single-book/${item.book._id}`}
                >
                  <h4>
                    نام {kind} : {item.book.title}
                  </h4>
                  <h4>صفحه : {item.page}</h4>
                  {/* {item.percentage && <h4>{item.percentage}%</h4>} */}
                </Link>
              ) : (
                <Link
                  style={key === 0 ? { marginTop: "0" } : {}}
                  key={key}
                  className={Styles.bookContainer}
                  to={
                    item.kind === "article"
                      ? `/article/journal/${item.articleId}`
                      : `/library/single-book/${item.bookId}`
                  }
                >
                  <h4>
                    نام {item.kind === "article" ? "مقاله" : "کتاب"} :{" "}
                    {item.title}
                  </h4>
                  {handleDeleteSavedItem && (
                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        handleDeleteSavedItem(
                          item.kind === "article"
                            ? item.articleId
                            : item.bookId,
                          item.kind
                        );
                      }}
                      src={deleteIcon}
                      alt=""
                    />
                  )}
                </Link>
              )
            )
          : "در حال حاضر اطلاعاتی موجود نیست"}
      </div>
    </div>
  );
};

export default UserPanelCard;
